import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import StorySection3 from '../../components/StorySection3/StorySection3';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar'
import StorySection from '../../components/StorySection';




const HomePage3 = () => {

    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-3'}/>
            <StorySection />
            <StorySection3 />
            <Footer footerClass={'wpo-site-footer-s2'}/>
            <Scrollbar />
        </Fragment>
    )
};

export default HomePage3;